module.exports = __webpack_public_path__ + "img/about-01.85d208a.svg";